module.exports = __webpack_public_path__ + "static/media/rouge.2c0e52c6.png";